import { useLingui } from "@lingui/react/macro"

interface Props {
  className?: string
}

export function InfoIcon(props: Props) {
  const { t } = useLingui()

  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <title>{t`Info Icon`}</title>
      <path
        d="M8.00098 2.66699C10.9465 2.66722 13.334 5.05462 13.334 8C13.334 10.9454 10.9465 13.3328 8.00098 13.333C5.05525 13.333 2.66699 10.9455 2.66699 8C2.66699 5.05448 5.05525 2.66699 8.00098 2.66699ZM8.00098 3.7334C5.6444 3.7334 3.7334 5.64359 3.7334 8C3.7334 10.3564 5.6444 12.2666 8.00098 12.2666C10.3574 12.2664 12.2676 10.3563 12.2676 8C12.2676 5.64373 10.3574 3.73363 8.00098 3.7334ZM8 7.28906C8.39267 7.28906 8.71079 7.60736 8.71094 8V10.1328C8.71094 10.5256 8.39276 10.8438 8 10.8438C7.60743 10.8435 7.28906 10.5254 7.28906 10.1328V8C7.28921 7.6075 7.60752 7.28929 8 7.28906ZM8 5.15527C8.39259 5.15527 8.7107 5.47368 8.71094 5.86621C8.71094 6.25895 8.39274 6.57715 8 6.57715C7.60749 6.57688 7.28906 6.25878 7.28906 5.86621C7.2893 5.47384 7.60764 5.15554 8 5.15527Z"
        fill="currentColor"
      />
    </svg>
  )
}
